import React, { useEffect, useState } from 'react';
import AudioTimer from './AudioTimer';
import { ReactMic } from 'react-mic';
import { MDBIcon, MDBBtn, MDBInput } from 'mdb-react-ui-kit';
import { uploadGreeting } from '../../apiclients/streamsapi_bridge';

const ReactRecorder = ({ setMicFileName, setMicRecFile, setMicName, activeTab }) => {
    const [isRunning, setIsRunning] = useState(false);
    const [elapsedTime, setElapsedTime] = useState(30000); // 5 minutes in milliseconds
    const [voice, setVoice] = useState(false);
    const [recordBlobLink, setRecordBlobLink] = useState(null);
    const [errorMessage, setErrorMessage] = useState('');
    const [errorNameMessage, setErrorNameMessage] = useState('');

    useEffect(() => {
        if (activeTab) {
            setErrorMessage('');
            setErrorNameMessage('');
        }
    }, [activeTab]);

    async function onStop(recordedBlob) {
        try {
            setRecordBlobLink(recordedBlob.blobURL);
            const binaryStreamData = await fetch(recordedBlob.blobURL);
            let blob = await binaryStreamData.blob();

            // MIME type 
            const mimeType = blob.type || "audio/mp3"; // Set a default if missing
            const fileName = `recording_${Date.now()}.mp3`; // Add a proper extension

            // Blob url having filename with extension and mime type
            const file = new File([blob], fileName, { type: mimeType });
            
            setMicRecFile(file);
          
        } catch (e) {
            console.log(`error::${e}`);
        }
    }

    const startHandle = () => {
        setElapsedTime(30000); // Reset to 5 minutes
        setIsRunning(true);
        setVoice(true);
    };

    const stopHandle = () => {
        setIsRunning(false);
        setVoice(false);
    };

    const clearHandle = () => {
        setIsRunning(false);
        setVoice(false);
        setRecordBlobLink(null);
        setElapsedTime(300000); // Reset to 5 minutes
    };



    const handleInputChange = (event) => {
        const { value } = event.target;
        const fileNameRegex = /^[a-zA-Z0-9_-]*$/;
        if (fileNameRegex.test(value)) {
            setMicFileName(value);
            setErrorMessage('');
        } else {
            setErrorMessage('Invalid file name. Only letters, numbers, underscores, hyphens, and periods are allowed.');
        }
    };
    const handleNameChange = (event) => {
        const { value } = event.target;
        const trimmedValue = value.trim();
        const fileNameRegex = /^([a-zA-Z0-9])([a-zA-Z0-9_\- ])*$/;
            if(trimmedValue === ""){
            setErrorNameMessage("Name is required.")
        }
       else if (fileNameRegex.test(trimmedValue)) {
            setMicName(trimmedValue);
            setMicFileName(trimmedValue);
            setErrorNameMessage('');
        } else {
            setErrorNameMessage('Invalid file name. Only letters, numbers, underscores, hyphens are allowed.');
            setMicName(null);
        }
    };

    return (
        <div>
            <div className="">
                <div className='d-flex align-items-center'>
                    <ReactMic
                        record={voice}
                        mimeType='audio/mp3'
                        className={`w-85 ${voice ? '' : 'd-none'}`}
                        onStop={(data) => onStop(data)}
                        strokeColor="#3b71ca"
                    />
                    {voice && (
                        <>
                            <div className='ms-2'>
                                <AudioTimer
                                    isRunning={isRunning}
                                    setIsRunning={setIsRunning}
                                    elapsedTime={elapsedTime}
                                    setElapsedTime={setElapsedTime}
                                />
                            </div>
                        </>
                    )}
                </div>

                {!voice && recordBlobLink ? (
                    <>

                        <div>
                            <label>Name:<span className='text-danger'>*</span></label>
                            <div className='w-100 my-2 mb-3'>
                                <MDBInput maxLength={60}
                                    onChange={handleNameChange}
                                />
                                {errorNameMessage && <p className="text-danger">{errorNameMessage}</p>}
                            </div>
                        </div>

                        {/* <div>
                            <label>File Name:<span className='text-danger'>*</span></label>
                            <div className='w-100 mt-2'>
                                <MDBInput
                                    onChange={handleInputChange}
                                />
                            </div>
                        </div>
                        <p className='text-secondary small'>Greeting file name can be alphanumeric and can include underscore(_) and hyphen(-)</p>
                        {errorMessage && <p className="text-danger text-small">{errorMessage}</p>} */}
                        <div className="w-100 d-flex justify-content-center mb-3">
                            <audio controlslist="nodownload" controls src={recordBlobLink} className="mt-6" preload="auto" />
                        </div>
                    </>
                ) : null}

                <div className="my-4 w-100 d-flex justify-content-center">
                    {!voice ? (
                        <MDBBtn
                            className={recordBlobLink ? 'w-50' : 'w-100'}
                            rounded
                            onClick={(event) => {
                                event.preventDefault();
                                event.stopPropagation();
                                if (!voice && recordBlobLink) {
                                    clearHandle();
                                    startHandle();
                                } else {
                                    startHandle();
                                }
                            }}
                        >
                            <MDBIcon far icon="dot-circle" className="me-2" />
                            {recordBlobLink ? "Restart" : "Record"}
                        </MDBBtn>
                    ) : (
                        <MDBBtn onClick={(event) => {
                            event.preventDefault();
                            event.stopPropagation();
                            stopHandle();
                        }}>
                            Stop
                        </MDBBtn>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ReactRecorder;
